var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue",
      },
    ],
    staticClass: "ak-form__control",
    domProps: { value: _vm.currentValue },
    on: {
      change: _vm.valueChanged,
      input: function ($event) {
        if ($event.target.composing) {
          return
        }
        _vm.currentValue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }